import { render, staticRenderFns } from "./MobileMenuTrigger.vue?vue&type=template&id=551bc437&"
import script from "./MobileMenuTrigger.vue?vue&type=script&lang=js&"
export * from "./MobileMenuTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports